<!-- Ported from vendor-ref/mara/app/ui/src/components/nanome/WorkspaceToolBar.vue (SetTool -> store.setTool; comment button dropped) -->
<script setup lang="ts">
import Button from 'primevue/button';
import { useLiteStore, type Tool } from '@nanome-lite/state';
import { TOOLS } from '@/data/viewer-tools';

const store = useLiteStore();
const tools = Object.keys(TOOLS) as Tool[];
</script>

<template>
  <div class="flex flex-col items-center gap-1 bg-xr rd-full p-1">
    <Button
      v-for="key in tools"
      :key="key"
      v-tooltip.left="TOOLS[key].label"
      :icon="TOOLS[key].icon"
      :severity="store.view.tool === key ? 'primary' : 'secondary'"
      :text="store.view.tool !== key"
      size="small"
      rounded
      @click="store.setTool(key)"
    />
  </div>
</template>
